module.exports = __webpack_public_path__ + "static/media/kafkaml.9c0f9867.png";